import _normalizeUrl, { type Options } from 'normalize-url';

const defaultOptions: Options = {
    stripHash: false,
    stripAuthentication: false,
    stripWWW: false,
    defaultProtocol: 'https',
    removeDirectoryIndex: [],
    removeQueryParameters: [],
    removeTrailingSlash: false,
    removeSingleSlash: false,
};

/**
 * Normalize a url.
 */
export function normalizeUrl(url: string, options: Options = {}): string {
    if (!url.startsWith('mailto:')) {
        try {
            if (url.includes('%0A')) {
                // If the url includes a new line char encoded, `normalize-url` will remove it and
                // doesn't provide an option to keep it. So we replace it with a placeholder that
                // won't be touched by `normalize-url` before normalization and replace it back after.
                const newLinePlaceholder = '__NEWLINE__';
                const urlWithPlaceholder = url.replace(/%0A/g, newLinePlaceholder);
                const normalizedUrl = _normalizeUrl(urlWithPlaceholder, {
                    ...defaultOptions,
                    ...options,
                });
                return normalizedUrl.replace(new RegExp(newLinePlaceholder, 'g'), '%0A');
            }

            return _normalizeUrl(url, { ...defaultOptions, ...options });
        } catch (_err) {
            // normalizeUrl throws an error if the url is not an HTTP(S) URL
            // in those cases we can't normalize as we don't know the protocol
            return url;
        }
    }
    return url;
}
